import React from 'react';
import './IconRight.css';
import PropTypes from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileMedical } from '@fortawesome/free-solid-svg-icons';

import { useStateContext } from '../../../../../contextProvider';

const MedicalRecordIcon = ({medicalStaffId, patientId, patientData, handleSeeDetails}) => {

  const { setSelectedPatient } = useStateContext()

    return (
        <div className="icon-right">
            <FontAwesomeIcon
                icon={faFileMedical}
                className="table-icon"
                color="#286F9E"
                onClick={() => {
                    setSelectedPatient(patientId)

                    localStorage.setItem('patient_id', String(patientId))
                    localStorage.setItem('staff_id', String(medicalStaffId))
                    localStorage.setItem('patient_data', JSON.stringify(patientData[0]))
                    localStorage.setItem("patient_name", patientData[0].name);
                    localStorage.setItem("patient_surname", patientData[0].surname);

                    handleSeeDetails({medicalStaffId: medicalStaffId, patientId: patientId, patientData: patientData});
                }}
            />
        </div>
    );
};

MedicalRecordIcon.propTypes = {
    medicalStaffId: PropTypes.number,
    patientId: PropTypes.number,
    patientData: PropTypes.array,
    handleSeeDetails: PropTypes.func,
};

export default MedicalRecordIcon;
